const { TRIAL_TARIFF_DAYS_DURATION } = require('../appConstants');
const {
    lite2024CommonName,
    professional2024CommonName,
    expert2024CommonName,
    ultimate2025CommonName,
} = require('./common-book-tariffs');

module.exports = {
    ULTIMATE_2025: {
        name: ultimate2025CommonName,
        description: `Le choix idéal si vous cherchez quelque chose d’unique et souhaitez utiliser Zenamu sans aucune limitation.`,
    },
    EXPERT_2024: {
        name: expert2024CommonName,
        description:
            'Je suis un expert indépendant ou un studio avec une équipe de deux instructeurs ou plus. Notre offre comprend une large gamme de cours, des ateliers spéciaux et des formations thématiques régulières.',
    },
    PROFESSIONAL_2024: {
        name: professional2024CommonName,
        description:
            "J'ai une pratique établie et des clients réguliers qui reviennent souvent. J'organise plusieurs cours par semaine et des formations à long terme avec plusieurs sessions.",
    },
    LITE_2024: {
        name: lite2024CommonName,
        description:
            "Je propose des cours hebdomadaires réguliers et j'organise parfois des ateliers spécialisés le week-end. Mes cours s'adressent à des participants réguliers.",
    },
    TRIAL_FREELANCER: {
        name: "Version d'essai avec fonctionnalités illimitées",
        description: `Essayez l'abonnement "Professeur indépendant" gratuitement pendant ${TRIAL_TARIFF_DAYS_DURATION} jours avec une nouvelle inscription.`,
    },
    TRIAL_STUDIO: {
        name: "Version d'essai avec fonctionnalités illimitées",
        description: `Essayez l'abonnement "Studio" gratuitement pendant ${TRIAL_TARIFF_DAYS_DURATION} jours avec une nouvelle inscription.`,
    },
    FREE: {
        name: 'Débutant',
        description:
            "Je propose des cours de manière irrégulière et plutôt occasionnelle. J'organise seulement quelques cours par mois pour un petit groupe de participants.",
    },
    FREELANCER_2024_COMPATIBILITY: {
        name: 'Professionnel',
        description: "Je suis un professeur. J'organise des cours ouverts, des ateliers ou des séminaires.",
    },
    STUDIO_2024_COMPATIBILITY: {
        name: 'Studio',
        description:
            'Nous organisons des cours, des sessions ouvertes ou des ateliers dirigés par plusieurs professeurs.',
    },
    STUDIO_PRO_2024_COMPATIBILITY: {
        name: 'Studio PRO',
        description:
            'Nous organisons des cours, des sessions ouvertes ou des ateliers dirigés par plusieurs professeurs.',
    },
};
